// Fase D: modulo de accesos en la consola del admin. Apagado por defecto (VITE_CONDO_ACCESS) hasta que Backend libere
// devices, guards y access/log. Con el flag encendido llama a la API real; los mocks solo existen en las pruebas (Vitest).
type Env = Record<string, string | boolean | undefined>;
const viteEnv = (): Env => import.meta.env as unknown as Env;

export function isAccessModuleEnabled(env: Env = viteEnv()): boolean {
  return env.VITE_CONDO_ACCESS === 'true';
}
